import { getApplePayConfig, getGooglePayConfig } from '@/core/services/groups'
import {
  mapApplePayConfigFromApi,
  mapGooglePayConfigFromApi,
} from './enumMappers'
import { IApplePayConfigForm, IGooglePayConfigForm } from './types'

// Apple/Google Pay configs aren't returned with the festival payload, so they
// are fetched per payment provider (on load, and when the payment type is
// selected) and mapped into the form shape.
export const loadApplePayConfig = async (
  paymentProviderId: string,
  festivalName?: string,
): Promise<IApplePayConfigForm | undefined> => {
  if (!paymentProviderId) return undefined
  try {
    const res = await getApplePayConfig(paymentProviderId, festivalName)
    if (res.status !== 200 || !res.data) return undefined
    const config = res.data
    return {
      configId: config.id,
      festivalId: config.festivalId,
      countryCode: config.countryCode,
      merchantIdentifier: config.merchantIdentifier,
      displayName: config.displayName,
      ...mapApplePayConfigFromApi(config),
      stripePublishableKey: config.stripePublishableKey,
      hasCertificate: config.hasCertificate,
      hasPrivateKey: config.hasPrivateKey,
    }
  } catch {
    return undefined
  }
}

export const loadGooglePayConfig = async (
  paymentProviderId: string,
  festivalName?: string,
): Promise<IGooglePayConfigForm | undefined> => {
  if (!paymentProviderId) return undefined
  try {
    const res = await getGooglePayConfig(paymentProviderId, festivalName)
    if (res.status !== 200 || !res.data) return undefined
    const config = res.data
    return {
      configId: config.id,
      festivalId: config.festivalId,
      countryCode: config.countryCode,
      environment: config.environment,
      gateway: config.gateway,
      merchantName: config.merchantName,
      merchantId: config.merchantId,
      ...mapGooglePayConfigFromApi(config),
      stripeVersion: config.stripeVersion,
      stripePublishableKey: config.stripePublishableKey,
    }
  } catch {
    return undefined
  }
}
